import { render, staticRenderFns } from "./teamChange.vue?vue&type=template&id=1c83a014&lang=html&"
import script from "./teamChange.vue?vue&type=script&lang=ts&"
export * from "./teamChange.vue?vue&type=script&lang=ts&"
import style0 from "./teamChange.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports